<a href="javascript:void(0)" [name]="getAnchorName()"></a>
<ng-content select="center-content"></ng-content>
<div class="content">
  <ng-content></ng-content>
</div>
